/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext, useState, type ReactNode } from 'react';

type PageHeader = {
  title?: string;
  backPath?: string | number;
};

type PageHeaderContextType = {
  header: PageHeader;
  setHeader: (header: PageHeader) => void;
};

const PageHeaderContext = createContext<PageHeaderContextType | undefined>(
  undefined
);

export function PageHeaderProvider({ children }: { children: ReactNode }) {
  const [header, setHeader] = useState<PageHeader>({});
  return (
    <PageHeaderContext.Provider value={{ header, setHeader }}>
      {children}
    </PageHeaderContext.Provider>
  );
}

export function usePageHeader() {
  const ctx = useContext(PageHeaderContext);
  if (!ctx)
    throw new Error('usePageHeader must be used within PageHeaderProvider');
  return ctx;
}
